import { useState, useEffect} from 'react'
import MD5 from "crypto-js/md5"

import { getRefreshSSO } from './SSO'
import { useLogout, useClearSession } from './useLogin'
import { encodeStorage, decodeStorage, removeStorage } from './storageBase64'
import { getCookie } from './getCookie'

export function useToken(props = false){

    const {
        timeRef = 100,
        firstActive = true,
        name
    } = props

    const [readyActive, setReadyActive] = useState(firstActive)

    useEffect(()=>{
        if(firstActive){
            setReadyActive(true)
        }else{
            setReadyActive(false)
        }
        if(name){
            // console.log('nombreHookToken: ',name)
        }
    },[firstActive])

    const { logOut } = useLogout()
    const { clearSession } = useClearSession()

    let domain
    const [tokenCookie, setTokenCookie] = useState( )
    const [tokenRCookie, setTokenRCookie] = useState( )
    const [tokenStore, setTokenStore] = useState( )
    const [tokenRStore, setTokenRStore] = useState( )
    const [tokenTime, setTokenTime ] = useState( )
    const [tokenTimeR, setTokenTimeR ] = useState( )
    const [errorToken, setErrorToken ] = useState(null)

    /*  Actualiza el tiempo  */
    const [tiempoActual, setUpdateTiempoActual] = useState( Date.now() )
    const [updateFunction, setUpdateFunction] = useState()
    const liveToken = () =>{
        setUpdateTiempoActual( Date.now() )
        setUpdateFunction(Date.now())
    }

    const [forceUpdateToken, setForceUpdateToken] = useState(false)
    const forceToken = force =>{
        setForceUpdateToken(force)
        console.log('se intenta el forzado: ', force)
    }

    //Inicio para next :S
    useEffect(()=>{
        setTokenCookie( getCookie('access_token') )
        setTokenRCookie( getCookie('refresh_token') )
        setTokenStore( decodeStorage('access_token') )
        setTokenRStore( decodeStorage('refresh_token') )
        setTokenTime( decodeStorage('access_token_exp') )
        setTokenTimeR( decodeStorage('refresh_token_exp') )
        domain = window.location.hostname
    },[])


    /*  Si existe storage toma los datos, si no existe busca datos de la cookie y los guarda al storage  */
    useEffect(()=>{
        if(tokenStore){
            // console.log('Existe en storage y toma los datos')
            setTokenTime( decodeStorage('access_token_exp') )
            setTokenTimeR( decodeStorage('refresh_token_exp') )
        }
        else if(tokenCookie && tokenRCookie){
            // console.log('No existe storage, busca datos de la cookie y los guarda al storage')
            encodeStorage('access_token', tokenCookie )
            encodeStorage('refresh_token', tokenRCookie )

            let tokenJWT = JSON.parse( atob(tokenCookie.split('.')[1]) )
            let tokenRefreshJWT = JSON.parse( atob(tokenRCookie.split('.')[1]) )
            
            
            encodeStorage('access_token_exp', tokenJWT.exp)
            encodeStorage('refresh_token_exp', tokenRefreshJWT.exp)

            setTokenTime( decodeStorage('access_token_exp') )
            setTokenTimeR( decodeStorage('refresh_token_exp') )
        }
        else{
            // console.log('No existe ni cookie ni storage')
        }

        
        if(readyActive){
            // console.log('---------------------------------------')
            // console.log('cookie TC: ', tokenCookie)
            // console.log('storage TC: ', tokenStore)
            // console.log('cookie TRC: ', tokenRCookie)
            // console.log('storage TRC: ', tokenRStore)
            // console.log('tokenRefresh: ', tokenTimeR)
            // console.log('token: ', tokenTime)
            // console.log('actual: ', tiempoActual/1000 )
            // console.log('---------------------------------------')
            // let tokenActual = new Date(decodeStorage('access_token_exp') * 1000)
            // console.log('actual: ', Date() )
            // console.log('token: ', tokenActual )
            // let refreshActual = new Date(decodeStorage('refresh_token_exp') * 1000)
            // console.log('refresh: ', refreshActual )
        }

    },[updateFunction])
    

    const [tokenR, getTokenR] = useState()
    useEffect(()=>{
        if(readyActive || forceUpdateToken){
            let tokenStoreLocal = decodeStorage('access_token')
            let refreshTStoreLocal = decodeStorage('refresh_token')
            let access_token_exp = decodeStorage('access_token_exp')
            let refresh_token_exp = decodeStorage('refresh_token_exp')
            
            setTimeout(function(){
                console.log('timeRef: ', timeRef)
                
                if(tokenCookie || tokenStore || tokenStoreLocal){
                    /* Evalua que el tiempo no sea mayor a 3 meses, si es asi manda a login */
                    if((tokenTimeR || tokenTime) || (refresh_token_exp || access_token_exp) ){
                        /* Forza el update del token  */
                        if(forceUpdateToken){
                            if(refreshTStoreLocal){
                                setForceUpdateToken(false)
                                getRefreshSSO()
                                .then(getTokenR)
                            }
                        }
                        else if(tiempoActual >= (tokenTimeR * 1000) && tiempoActual >= (refresh_token_exp * 1000) ){
                            // console.log('El token lleva mas de 3 meses')
                            try{
                                window.ineum('meta', 'Logout', "refresTokenExpOut")
                            }catch(e){}
                            logOut()
                            setTimeout(function(){
                                window.location.replace(`${window.location.origin}/login?redirect=${window.location.href}`)
                            },700)
                        }
                        /* Evalua que el tiempo no sea mayor a 30 minutos, si es asi actauliza el token  */
                        else if(tiempoActual >= ( (tokenTime * 1000) - 10000 ) && tiempoActual >= ( (decodeStorage('access_token_exp') * 1000) - 10000 ) ){
                            
                            // console.log('a:  ', tiempoActual >= ( (tokenTime * 1000) - 10000 ))
                            // console.log('b:  ', tiempoActual >= ( (decodeStorage('access_token_exp') * 1000) - 10000 ))
                            // console.log('c:  ', tiempoActual )
                            // console.log('d:  ', (tokenTime * 1000) - 10000  )
                            // console.log('e:  ', (decodeStorage('access_token_exp') * 1000) - 10000  )
                            // console.log('------------------------------------>')
                            
                            // console.log('El token lleva mas de 30min')
                            if(refreshTStoreLocal){
                                getRefreshSSO()
                                .then(getTokenR)
                            }
                        }
                    }else{
                        // console.log('si no tienen refresh token y acces token exp')
                        logOut()
                        setTimeout(function(){
                            window.location.replace(`${window.location.origin}/login?redirect=${window.location.href}`)
                        },700)
                    }
                }
            },timeRef)
        }

    },[updateFunction, forceUpdateToken])
    

    /* Actauliza los datos despues de que la respuesta sea success */
    const [newToken, setNewToken] = useState()
    useEffect(()=>{
        let domain = window.location.hostname
        // console.log('tokenR: ', tokenR)
        if(tokenR){
            if(tokenR?.statusCode === 200 ){
                document.cookie = `access_token=;Max-Age=${0};Path=/;Domain=${domain};`
                document.cookie = `refresh_token=;Max-Age=${0};Path=/;Domain=${domain};`
                document.cookie = `token_login=;Max-Age=${0};Path=/;Domain=${domain};`;
                document.cookie = `token_cart=;Max-Age=${0};Path=/;Domain=${domain};`;

                if(tokenR?.data){

                    let tokenJWT = JSON.parse( window.atob(tokenR?.data?.access_token?.split('.')[1]) )
                    let tokenRefreshJWT = JSON.parse(  window.atob(tokenR?.data?.refresh_token?.split('.')[1]) )

                    encodeStorage('session_token', tokenR?.data?.access_token)
                    encodeStorage('access_token', tokenR?.data?.access_token)
                    encodeStorage('refresh_token', tokenR?.data?.refresh_token)
                    encodeStorage('idCarrito', MD5(`${tokenJWT?.email}`).toString() )

                    encodeStorage('access_token_exp', tokenJWT?.exp)
                    encodeStorage('refresh_token_exp', tokenRefreshJWT?.exp)

                    setTokenTime( decodeStorage('access_token_exp') )
                    setTokenStore( decodeStorage('access_token') )
                    setTokenTimeR( decodeStorage('refresh_token_exp') )
                    setTokenRStore( decodeStorage('refresh_token') )

                    document.cookie = `token_cart=${ MD5(`${tokenJWT?.email}`).toString() };Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
                    document.cookie = `token_login=${tokenR?.data?.access_token};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
                    document.cookie = `access_token=${tokenR?.data?.access_token};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
                    document.cookie = `refresh_token=${tokenR?.data?.refresh_token};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
                    
                    setNewToken(tokenJWT.exp)
                }
                setErrorToken(null)
            }
            else if( tokenR.statusCode === 400 ){
                encodeStorage('reasonLastLogout', tokenR?.data?.error)
                setErrorToken(tokenR?.statusCode)
                try{
                    // console.log('dio un 400: ', tokenR?.data?.error)
                    window.ineum('meta', 'reasonLastLogout', tokenR?.data?.error)
                }catch(e){}

                if(tokenR?.data?.error === "invalid_grant" ){
                    clearSession()
                    setTimeout(function(){
                        window.location.replace(`${window.location.origin}/login?redirect=${window.location.href}`)
                    },1500)                  
                }
                else if( tokenR?.data?.error === "invalid_client" || tokenR?.data?.error === "unauthorized_client" ||  tokenR?.data?.error === "invalid_request"){
                    clearSession()
                    setTimeout(function(){                  
                        window.location.replace(`${window.location.origin}`)
                    },1500)                  
                }else{
                    clearSession()
                    setTimeout(function(){                  
                        window.location.replace(`${window.location.origin}`)
                    },1500)                  
                }
            }
            else if( tokenR?.statusCode === 401 ){
                // console.log('no tiene permisos el token, ¿Lo mandamos al login y le damos logout? ')
                logOut()
            }
            else if( tokenR?.statusCode >= 500 ){
                // console.log('error en el server alias un 500 ton')
                setErrorToken(tokenR?.statusCode)
                encodeStorage('access_token_exp', ((Date.now()/1000) + 300) )
            }
        }else{
            // setErrorToken('Network Error')
            // clearSession()
        }
    },[tokenR])
    
    return { newToken, liveToken, forceToken, errorToken }
}